/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

$(function () {
  var hotzones = $('.Hotzonebox-full .hotzonebox')
  if (hotzones.length) {
    var coordinatesMapShapes = function (e) {
      var setNewCoords = function (hotzone, scale) {
        hotzone.find('area').each(function () {
          var coords = $(this).data('coords')
          if(!coords) {
            coords = $(this).attr('coords')
            $(this).data('coords', coords)
          }
          var oldCoords = coords.split(",");
          for (var i = 0, len = oldCoords.length; i < len; i++) {
            oldCoords[i] = oldCoords[i] * scale;
          }
          // 设置新热区位置
          $(this).attr('coords', oldCoords.join())
        })
      }
      hotzones.each(function () {
        var hotzone = $(this);
        var setWidth = hotzone.find('div').data('width') * 1;
        if (!!setWidth) {
          hotzone.find('img').each(function () {
            if(e) {
              setNewCoords(hotzone, $(this).width() / setWidth)
            } else {
              var img = $(this)
              var tmpImg = new Image();
              tmpImg.src = this.src;
              tmpImg.onload = function() {
                setNewCoords(hotzone, img.width() / setWidth)
              };
            }
          })
        }
      })
    }
    coordinatesMapShapes();
    $(window).on('resize', debounce(coordinatesMapShapes, 500));
  }
})


$(function(){ 
  $('.Product__Tabs .descriptionPart').find('.Collapsible__Button').trigger("click"); 
  $("#backTop").click(function() {
    $("html, body").animate({
      scrollTop: $("html, body").offset().top }, {duration: 400,easing: "swing"});
    return false;
  });
  window.onscroll = function(e){
    var e =e || window.event;
    var scrolltop=document.documentElement.scrollTop||document.body.scrollTop;
    if(scrolltop>300){
      $("#backTop").fadeIn(200)
    }else {
      $("#backTop").fadeOut(200)
    }
  }
})

$(function(){
  $('.Footer__Inner .Footer__Block--links .footer-tree-top').click(function(){
    $(this).children('.top-icon').toggleClass('rotate-icon');
    $(this).next('.footer-tree-content').toggleClass('footer-content-active').slideToggle();
  });
}) 